import { AxiosResponse } from "axios";
import instance from "../instance";

interface AuthLinkInterface {
  redirect_url: string;
}
export const getAuthLink = async (): Promise<string> => {
  try {
    const res: AxiosResponse<AuthLinkInterface> = await instance.get(
      `/auth/social/flru/`
    );
    return res.data.redirect_url;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
